module.exports = __webpack_public_path__ + "WealthCare Saver Booklet Guide.pdf";